import classNames from 'classnames'

export function NumberBubble({
  count,
  className,
}: {
  count: number
  className?: string
}) {
  return (
    <strong
      className={classNames(
        'flex flex-row items-center justify-center rounded-full bg-fixed-accent-color text-label-small text-on-surface',
        {
          'h-4 w-4': count < 10,
          'h-5 w-5': count >= 10 && count < 100,
          'h-6 w-6': count >= 100,
        },
        className
      )}
    >
      {count > 99 ? '99+' : count}
    </strong>
  )
}
